import React, { useState } from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Typography,
  Divider,
} from '@mui/material';

const ApproveTransferDialog = ({
  open,
  onClose,
  transferRequest,
  onApprove,
  onDeny,
  isLoading = false,
}) => {
  const [notes, setNotes] = useState('');
  const [action, setAction] = useState(null);

  const handleApprove = () => {
    setAction('approve');
    onApprove(notes.trim() || undefined);
  };

  const handleDeny = () => {
    setAction('deny');
    onDeny(notes.trim() || undefined);
  };

  const handleClose = () => {
    setNotes('');
    setAction(null);
    onClose();
  };

  if (!transferRequest) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {action === 'approve' ? 'Approve' : action === 'deny' ? 'Deny' : 'Review'} Transfer Request
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" color="textSecondary" gutterBottom>
            Device Information
          </Typography>
          <Typography variant="body2">MAC Address: {transferRequest.device_detail?.mac_addr || transferRequest.device?.mac_addr || 'N/A'}</Typography>
          {(transferRequest.device_detail?.user || transferRequest.device?.user) && (
            <Typography variant="body2">
              Current Owner: {(transferRequest.device_detail?.user || transferRequest.device?.user).display_name || (transferRequest.device_detail?.user || transferRequest.device?.user).email}
            </Typography>
          )}
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" color="textSecondary" gutterBottom>
            Transfer Details
          </Typography>
          <Typography variant="body2">
            <strong>Requested By:</strong> {transferRequest.requested_by_detail?.display_name || transferRequest.requested_by?.display_name || transferRequest.requested_by_detail?.email || transferRequest.requested_by?.email || 'N/A'}
          </Typography>
          <Typography variant="body2">
            <strong>Transfer To:</strong> {transferRequest.requested_to_detail?.display_name || transferRequest.transfer_to_user?.display_name || transferRequest.requested_to_detail?.email || transferRequest.transfer_to_user?.email || 'N/A'}
          </Typography>
          <Typography variant="body2">
            <strong>Requested Date:</strong> {(transferRequest.requested_at || transferRequest.requested_date) ? new Date(transferRequest.requested_at || transferRequest.requested_date).toLocaleString() : 'N/A'}
          </Typography>
          {transferRequest.notes && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              <strong>Notes:</strong> {transferRequest.notes}
            </Typography>
          )}
        </Box>

        <Divider sx={{ my: 2 }} />

        <TextField
          label="Your Notes (Optional)"
          fullWidth
          multiline
          rows={4}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Add notes about your decision..."
          disabled={isLoading || action !== null}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading || action !== null}>
          Cancel
        </Button>
        <Button
          variant="outlined"
          color="error"
          onClick={handleDeny}
          disabled={isLoading || action !== null}
          startIcon={action === 'deny' && isLoading ? <CircularProgress size={16} /> : null}
        >
          Deny
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={handleApprove}
          disabled={isLoading || action !== null}
          startIcon={action === 'approve' && isLoading ? <CircularProgress size={16} /> : null}
        >
          Approve
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApproveTransferDialog;



